<!-- 文章标签管理 -->
<template>
  <div style="padding: 20px;background-color: #fff;">
    <el-button type="primary" plain icon="el-icon-plus" @click="editHandle('add')">新增标签</el-button>
    <el-table
    :data="dataList"
    max-height="600"
    >
      <el-table-column
      label="序号"
      width="100"
      >
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
      prop="id"
      label="ID"
      width="100"
      >
      </el-table-column>
      <el-table-column
      prop="label"
      label="标签名"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建日期"
        width="150"
        >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改日期"
        width="150"
        >
      </el-table-column>
      <el-table-column
      label="操作"
      align="center"
      width="300"
      >
        <template slot-scope="{ row }">
          <el-button @click="editHandle('edit',row)" size="mini">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
    :visible.sync="tagVis"
    width="400px"
    >
      <el-input v-model="tagText" placeholder="输入标签内容"></el-input>
      <span slot="footer">
        <el-button @click="subTag" type="primary">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      dataList: [],
      tagVis: false,
      tagText: '',
      oType: '',
      tID: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      axios.post(`${this.$store.state.apiUrlZero}/TuZero/selectLabelTable`)
      .then(res => {
        this.dataList = [...res.data.data]
      })
    },
    editHandle(type,data) {
      this.tagText = ''
      this.tID = ''
      if(type == 'edit') {
        this.tagText = data.label
        this.tID = data.id
      }
      this.tagVis = true
      this.oType = type
    },
    subTag() {
      if(this.tagText == '') {
        this.$message.warning('未填标签内容')
        return
      }
      axios({
        url:`${this.$store.state.apiUrlZero}${this.oType == 'add' ? '/TuZero/insertLabel' : '/TuZero/updateLabel'}`,
        method: this.oType == 'add' ? 'post' : 'put',
        data: {
          label: this.tagText,
          id: this.tID
        }
      })
      .then(res => {
        this.getData()
        this.tagVis = false
      })
      .catch(error => {
        console.log(error)
        this.$message.error('操作失败')
      })
    },
  }
}
</script>

<style>

</style>